import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class BidEquipmentBus extends BaseBus{
    constructor(busObj: BidEquipmentBus) {
        super(busObj);

    }
    CID(): any {
        return this.bidEquipmentId;
    }
    setId(id: any) {
        this.bidEquipmentId = id;
    }
    initialize(data: BidEquipmentBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
       this.bidDetId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidEquipmentBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    bidEquipmentId:string;
    bidDetId:string;
    description:string;
    material:number;
    labor:number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    sortOrder  : number;
    public dragging: boolean
    isDelete: boolean;
}